module.exports = __webpack_public_path__ + "baocheng.jpg?6d19ae4bd207f115251df4b36ace109d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/baocheng.jpg
// module id = 64
// module chunks = 0